module.exports = __webpack_public_path__ + "img/hardwareRouter5.62385f21.png";